import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-select-option-status"
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-down" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "ui-select-status-opt"
}
const _hoisted_6 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showArrow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "circle mr-2",
            style: _normalizeStyle({ 'background-color': _ctx.color })
          }, null, 4),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.nameSelect), 1)
        ]),
        _hoisted_4
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "circle mr-2",
          style: _normalizeStyle({ 'background-color': _ctx.color })
        }, null, 4),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.nameSelect), 1)
      ]))
}